import React, { useEffect, useState, Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { request } from 'graphql-request';
import ArrowLeft from './img/arrow-left.png';
import EdgeLogo from './img/emm-logo-large.png';
import SwipeableViews from 'react-swipeable-views';
import EdgeLogoWhite from './img/EMM_Logo_Wht_Small.png';
import Car from './Car_photoswiper';
import './Css.sass';

const styles = {
    slide: {
      padding: 15,
      minHeight: 100,
      color: '#fff',
    },
    slide1: {
      background: '#FEA900',
    },
    slide2: {
      background: '#B3DC4A',
    },
    slide3: {
      background: '#6AC0FF',
    },
  };

function App() {
    function set() { setShowIndex(true); }
    const [cars, setCars] = useState(null);
    const [showIndex, setShowIndex] = useState(true);
    if (typeof localStorageOnDisplay == undefined) {
        localStorage.setItem('localStorageOnDisplay', 'yes');
    }
    var carsOnDisplay = localStorage.getItem('localStorageOnDisplay');


    useEffect(() => {
        if (carsOnDisplay == 'yes') {
            var query = 'orderBy:year_ASC, where: { onDisplay: false }';
        } else {
            var query = 'orderBy:year_ASC, where: { onDisplay: true }';
        }

        const fetchCars = async () => {
          const { cars } = await request(
            'https://api-us-east-1.graphcms.com/v2/ckm9bltzum38701yr1hcafwql/master',
            `
            {
                cars (orderBy:year_ASC) {

                    id
                    title
                    slug
                    year
                    make
                    model
                    story
                    engine
                    horsepower
                    fuelDelivery
                    transmission
                    onDisplay
                    showcaseImage:showcaseImage {
                        url(transformation: {image: {resize: {fit: max, height: 400, width: 600}}})
                    }
                    showcaseImageTiny:showcaseImage {
                        url(transformation: {image: {resize: {fit: max, height: 88, width: 100}}})
                    }
                    gallery {
                        id
                        url(transformation: {image: {resize: {fit: max, width: 1000, height: 1000}}})
                        smallURL: url(transformation: {image: {resize: {fit: max, width: 44, height: 44}}})
                        thumbnailURL: url(transformation: {image: {resize: {fit: max, width: 300, height: 300}}})
                        largeURL: url(transformation: {image: {resize: {fit: max, width: 1400, height: 1600}}})
                        rawURL: url
                        handle
                        imgW: width
                        imgH: height
                    }
                }
            }
            `
          );
          setCars(cars);
        };
          fetchCars();
        }, []);



    // Define Nav
    function Nav(props) {
        return (
            <>
                <nav class={props.pg}>
                    <Link to='/'><img src={ ArrowLeft } alt='go back'/></Link>
                    <img src={ EdgeLogo } alt='Edge Motor Museum logo' className='edge-logo'/>
                </nav>
            </>
        );
    }
    // Define Footer
    function Footer(props) {
        return (
            <footer class={props.pg}>
                <a href="https://www.edgemotormuseum.com/"><img src={ EdgeLogo } alt='Edge Motor Museum logo' className='edge-logo'/></a>
            </footer>
        );
    }


    // Create loop for displaying list of all cars:

    function ShowCars(props) {
        const viewOnDisplay = localStorage.getItem('localStorageOnDisplay');
        console.log("Only show what's on display? " + viewOnDisplay);
        return (
            <div className={viewOnDisplay}>
            <ul class={props.pg == "home" ? "home-index" : "car-page-index"}>
                {cars.map(({ id, title, slug, year, make, model, showcaseImageTiny, showcaseImage, onDisplay}) => (
                    <li key={id} className={onDisplay ? "onDisplay" : "notOnDisplay" }>
                        <div class="padding">
                            <Link to={`/cars/${slug}`}>
                                {showcaseImageTiny ?
                                    <div className='ccCar'><img src={showcaseImageTiny.url} alt={title} className="featureImage featureImageTiny"/></div>
                                    :
                                    null
                                }
                                {showcaseImage ?
                                    <div className='ccCar'><img src={showcaseImage.url} alt={title} className="featureImage featureImageLarge"/></div>
                                    :
                                    null
                                }
                                <h2>{year} {make}<br/> <span>{model}</span></h2>
                            </Link>
                        </div>
                    </li>
                ))}
            </ul>
            </div>
        );
    }
    function showAllCars(){
        localStorage.setItem('localStorageOnDisplay', 'no');
        window.location.reload();
    }
    function showOnDisplayCars(){
        localStorage.setItem('localStorageOnDisplay', 'yes');
        window.location.reload();
    }
    var viewOnDisplay = null;
    var checkLocalStorage = localStorage.getItem('localStorageOnDisplay');
    if (checkLocalStorage == null) {
        var viewOnDisplay = 'onDisplay-no';
    } else {
        var viewOnDisplay = 'onDisplay-' + checkLocalStorage;
    }
  return (
    <div className="App">
      <Router>
          <>
            {!cars ? (
                <>
                    <Nav pg="homePage"/>
                    <div class="spacer"></div>
                </>
            ) : (
            <React.Fragment>

                <Switch>
                    <Route exact path="/">
                        <>
                            <Nav pg="homePage"/>
                            <div id="tabs" className={viewOnDisplay}>
                                <div className="tab" id="onDisplayCars" onClick={showOnDisplayCars}>
                                    On display
                                </div>
                                <div className="tab" id="allCars" onClick={showAllCars}>
                                    All cars
                                </div>
                            </div>
                            {showIndex ? ( <ShowCars pg="home"/> ):( null )}
                        </>
                    </Route>
                    <Route path="/cars/:slug">
                        <div id="car-detail-pg">
                            <Nav pg="carPage" />
                            <a class="skip-to-content-link" href="#main">Skip to content</a>
                            <div id="car-detail-page">
                                <Car cars={cars}/>
                            </div>
                            <ShowCars pg="car" />
                        </div>
                    </Route>
                </Switch>
            </React.Fragment>
            )}
        </>
      </Router>
      <Footer/>
    </div>
  );
}

export default App;
